import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { DeviceType } from "@is/constants";
import { api, createStoresRegisterDeviceUrl } from "@is/services";
import { RegisteredDevice } from "@is/types";

type Params = {
  deviceId: string;
  storeId: string;
  name: string;
  type: DeviceType;
};

type RegisterDeviceState = {
  isPending: boolean;
  error: Error | null;
  data: RegisteredDevice | null;
};

async function handleRegisterDevice(params: Params): Promise<RegisteredDevice> {
  const url = createStoresRegisterDeviceUrl();
  const data = (await api.post(url, params)) as RegisteredDevice;

  return data;
}

export const useRegisterDevice = (): [
  RegisterDeviceState,
  (params: Params) => Promise<RegisteredDevice>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<RegisteredDevice>();

  const registerDevice = useCallback(
    (params: Params) => dispatch(handleRegisterDevice(params)),
    [dispatch]
  );

  return [{ isPending, error, data }, registerDevice];
};
